import Hero from "@/components/home/Hero";
import { Philosophy, Marquee } from "@/components/home/Philosophy";
import WhatWeDo from "@/components/home/WhatWeDo";
import VenturesBento from "@/components/home/VenturesBento";
import { Capabilities, WhyUs, Process } from "@/components/home/Sections";
import { Approach, PartnershipBlock, FounderIntro } from "@/components/home/Stories";
import { SectionHead, FaqList, CtaBand } from "@/components/Blocks";
import { Reveal } from "@/components/motion";
import { Cta } from "@/components/Cta";
import { HOME_FAQS } from "@/data/faqs";
import { useSeo } from "@/lib/seo";

export default function Home() {
  useSeo(null, "SparkIdea Interactive builds its own software ventures and helps ambitious founders turn ideas into intelligent, scalable products.");
  return (
    <>
      <Hero />
      <Philosophy />
      <Marquee />
      <WhatWeDo />
      <VenturesBento />
      <Capabilities />
      <WhyUs />
      <Process />
      <Approach />
      <PartnershipBlock />
      <FounderIntro />
      <section className="border-t border-si-line py-24 sm:py-32" data-testid="home-faq-section">
        <div className="wrap grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead eyebrow="FAQ" title={["Questions,", "answered."]} />
            <Reveal delay={0.2} className="mt-8"><Cta to="/faq" variant="secondary" testId="home-faq-all">All FAQs</Cta></Reveal>
          </div>
          <Reveal className="lg:col-span-8"><FaqList items={HOME_FAQS} testId="home-faq" /></Reveal>
        </div>
      </section>
      <CtaBand testId="final-cta" />
    </>
  );
}
